/**
 * Environment, read once and validated at boot.
 *
 * Reading `import.meta.env` at the point of use scatters the same string across the codebase and
 * turns a missing variable into a 404 in production rather than a failure to start.
 */

type Env = {
  /** Absolute in production (`https://api.oritech.co.ke/api/v1`), relative in dev via the proxy. */
  readonly apiBaseUrl: string;
  readonly isProduction: boolean;
};

function required(name: string, fallback?: string): string {
  const value = import.meta.env[name] as string | undefined;

  if (value === undefined || value.length === 0) {
    if (fallback !== undefined) return fallback;
    throw new Error(
      `${name} is not set. Copy .env.example to .env.local and fill it in before running the app.`,
    );
  }

  return value;
}

export const env: Env = {
  // The relative default is what makes the dev proxy work: same-origin in development means
  // cookies, CORS and CSRF behave exactly as they will in production.
  apiBaseUrl: required('VITE_API_BASE_URL', '/api/v1'),
  isProduction: import.meta.env.PROD,
};
